export class FetalAntigenICDCodesClass {
  constructor(
    public O361910 = false,
    public O361920 = false,
    public O361930 = false,
    public otherFetalAntigenICDCodes = "",
  ) {}
}
